import { useTranslation } from 'react-i18next';
import { HiArrowsRightLeft, HiCheck } from 'react-icons/hi2';
import {
  Section,
  Container,
  Visual,
  SyncFlow,
  FlowSource,
  FlowSourceIcon,
  FlowSourceText,
  FlowSourceSub,
  FlowArrow,
  FlowItems,
  FlowItem,
  FlowItemLabel,
  FlowItemCount,
  Content,
  Label,
  Title,
  Description,
  FeatureList,
  FeatureItem,
  CheckIcon,
} from './PortalIntegration.styled';

export default function PortalIntegration() {
  const { t } = useTranslation();

  const features = t('portalIntegration.features', { returnObjects: true }) as string[];

  return (
    <Section id="portal-sadowy">
      <Container>
        <Visual>
          <SyncFlow>
            <FlowSource>
              <FlowSourceIcon>
                <HiArrowsRightLeft size={18} />
              </FlowSourceIcon>
              <div>
                <FlowSourceText>Portal Informacyjny Sądów</FlowSourceText>
                <FlowSourceSub>{t('portalIntegration.syncLabel')}</FlowSourceSub>
              </div>
            </FlowSource>
            <FlowArrow>↓</FlowArrow>
            <FlowItems>
              <FlowItem>
                <FlowItemLabel>{t('portalIntegration.syncItems.cases')}</FlowItemLabel>
                <FlowItemCount>{t('portalIntegration.syncItems.casesDesc')}</FlowItemCount>
              </FlowItem>
              <FlowItem>
                <FlowItemLabel>{t('portalIntegration.syncItems.hearings')}</FlowItemLabel>
                <FlowItemCount>{t('portalIntegration.syncItems.hearingsDesc')}</FlowItemCount>
              </FlowItem>
              <FlowItem>
                <FlowItemLabel>{t('portalIntegration.syncItems.documents')}</FlowItemLabel>
                <FlowItemCount>{t('portalIntegration.syncItems.documentsDesc')}</FlowItemCount>
              </FlowItem>
            </FlowItems>
          </SyncFlow>
        </Visual>
        <Content>
          <Label>{t('portalIntegration.label')}</Label>
          <Title>{t('portalIntegration.title')}</Title>
          <Description>{t('portalIntegration.description')}</Description>
          <FeatureList>
            {features.map((feature) => (
              <FeatureItem key={feature}>
                <CheckIcon>
                  <HiCheck size={18} />
                </CheckIcon>
                {feature}
              </FeatureItem>
            ))}
          </FeatureList>
        </Content>
      </Container>
    </Section>
  );
}
